module.exports = __webpack_public_path__ + "static/media/fivestars.67d85c68.svg";